import { ref, readonly } from 'vue';

const isMaintenanceMode = ref(false);

export function useMaintenance() {
  function setMaintenanceMode(value) {
    isMaintenanceMode.value = value;
  }

  function checkMaintenanceMode() {
    return isMaintenanceMode.value;
  }

  return {
    isMaintenanceMode: readonly(isMaintenanceMode),
    setMaintenanceMode,
    checkMaintenanceMode
  };
}